import classNames from 'classnames';
import { ContentBlock, FlexContainer, Txt } from 'components/index';
import styles from './AddressBlock.module.scss';

/**
 * AddressBlock
 *
 * @return {JSX.Element}
 */
const AddressBlock = ({ className, address }) => {
  return (
    <ContentBlock
      className={classNames(
        styles.AddressBlock,
        className,
        AddressBlock.displayName
      )}
    >
      <FlexContainer gapQuad column>
        <Txt>
          {address.line1}, {address.line2}
        </Txt>
        <Txt>{address.street}</Txt>
        <Txt>{address.district}</Txt>
        <Txt>{address.postcode}</Txt>
      </FlexContainer>
    </ContentBlock>
  );
};

AddressBlock.displayName = 'AddressBlock';

export default AddressBlock;
